import React from 'react';

import { FileAddOutlined, FileZipOutlined } from '@ant-design/icons';
import { Radio, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import { NSKeys } from '@app/i18n';
import { ORBIS_CATALOGS_LIST_TYPE } from '@app/services/appSettings';

import { ListType } from '../../interfaces';

export const ListTypeSwitch: React.FC = () => {
  const catalogsT = useTranslation(NSKeys.catalogs);
  const [listView, setListView] = useLocalStorage(ORBIS_CATALOGS_LIST_TYPE, ListType.ACTIVE);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentView = (searchParams.get('view') as ListType | null) || listView;

  React.useEffect(() => {
    if (!searchParams.get('view')) {
      setSearchParams({ view: listView });
    }
  }, []);

  const handleChange = (view: ListType) => {
    setListView(view);
    setSearchParams({ view });
  };

  return (
    <Radio.Group
      value={currentView}
      size="middle"
      buttonStyle="solid"
      style={{ display: 'flex', flexWrap: 'nowrap' }}
      onChange={(event) => handleChange(event.target.value)}>
      <Tooltip title={catalogsT.t('switchListTypeActive')}>
        <Radio.Button value={ListType.ACTIVE}>
          <FileAddOutlined />
        </Radio.Button>
      </Tooltip>
      <Tooltip title={catalogsT.t('switchListTypeArchive')}>
        <Radio.Button value={ListType.ARCHIVED}>
          <FileZipOutlined />
        </Radio.Button>
      </Tooltip>
    </Radio.Group>
  );
};
